export default {"src":"/_next/static/media/ticket.b8e63e2b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};